<style>
	.statistics div {
		width: 100%;
	}

	.statistics_name {
		width: 100%;
	}

	.statistics_number {
		margin-top: 5px;
		width: 20px;
	}
</style>
<template>
	<div ref="content" class="content background2 searchBox3">
		<div class="userNavBox">
			<div class="navSearch">
				<div class="searchBox-black">
					<label class="searchBox-label">人员</label>
					<div class="searchBox-condition" style="width: 150px">
						<!-- <el-select class="select-class" v-model="searchList.userId" placeholder="请选择">
							<el-option :label="'全部'" :value="''"></el-option>
							<el-option v-for="item in customerList" :key="item.id" :label="item.name" :value="item.id">
							</el-option>
						</el-select> -->
						<el-input class="input-class el-input" v-model="searchList.userId"></el-input>
					</div>
				</div>
				<div class="searchBox-black">
					<label class="searchBox-label">时间</label>
					<div class="searchBox-condition">
						<el-date-picker v-model="searchDate" type="daterange" range-separator="至"
							start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd">
						</el-date-picker>
					</div>
				</div>
				<div class="searchButton" @click="search({pageNo: 1,pageSize: pageSize})">查询</div>
			</div>
			<div class="navTable">
				<div class="tableTitle">
					<p class="title">详细内容</p>
					<excel-export :filename="utils.getNowFormatDate() + '工作量统计表' " :sheet="sheet">
						<!-- <div class="exportButton" v-if="this.menuList.indexOf('CD_511') != -1"> -->
						<div class="exportButton" @click="getExcelList()" v-if="menuList.indexOf('CD_511') != -1">
							导出
						</div>
					</excel-export>
				</div>
				<div class="tableBox list" ref="tableList" :style="{'padding-top':paddingTop}">
					<!-- <List ref="list" :tableData="tableData" :tableList="tableList" :pageSize="pageSize" :pageNo="pageNo" :checkBox="true"
					 @parentMethod="getInfo" @checkMethod="getCheckInfo"></List> -->
					<div class="list-content">
						<div class="list-table-block">
							<el-table class="black-table" :data="tableData" border style="width: 100%;height: 100%;"
								highlight-current-row @selection-change="change">
								<template v-if="checkBox">
									<el-table-column type="selection" width="55">
									</el-table-column>
								</template>
								<el-table-column header-align="center" align="center" label="序号" type="index"
									width="100">
								</el-table-column>
								<el-table-column header-align="center" align="center" label="人员名称" prop="supperName">
								</el-table-column>
								<el-table-column header-align="center" align="center" label="完成工单数量"
									prop="completeCount">
								</el-table-column>
								<el-table-column header-align="center" align="center" label="未完成工单数量"
									prop="unCompleteCount">
								</el-table-column>
								<el-table-column header-align="center" align="center" label="超过24小时接单数量"
									prop="dayTakeOrdersCount">
									<template slot-scope="scope">
										<span
											:style="{'color':scope.row.dayTakeOrdersCount>0? 'red':'#000000'}">{{scope.row.dayTakeOrdersCount}}</span>
									</template>
								</el-table-column>
								<el-table-column header-align="center" align="center" label="超过7天未完成订单数量"
									prop="weekUncompleteCount">
									<template slot-scope="scope">
										<span
											:style="{'color':scope.row.weekUncompleteCount>0? 'red':'#000000'}">{{scope.row.weekUncompleteCount}}</span>
									</template>
								</el-table-column>
								<!-- 					        <el-table-column :header-align="item.headerAlign" :align="item.align" :prop="item.column" :label="item.title"
					          :style="{'width':item.width}" v-for="(item,index) in tableList" :key="index">
					          <template slot-scope="scope">
					            <template v-if="item.termList">
					              <template v-for="(items,index) in item.termList">
					                <template v-if="items.id === scope.row[item.column]">
					                  <template v-if="items.color !== undefined && items.color !== ''">
					                    <span :style="{color:items.color}">{{item.termList[index].name}}</span>
					                  </template>
					                  <template v-else>
					                    {{item.termList[index].name}}
					                  </template>
					                </template>
					              </template>
					            </template>
					            <template v-else>
					              {{scope.row[item.column]}}
					            </template>
					          </template>
					        </el-table-column> -->
							</el-table>
						</div>
					</div>
				</div>

				<div ref="page" class="page">
					<div class="statistics">
						<div>
							<p style="statistics_name">完成总量</p>
							<p class="statistics_number">{{stateList.completeCount}}</p>
						</div>
						<div>
							<p style="statistics_name">未完成总量</p>
							<p class="statistics_number">{{stateList.unCompleteCount}}</p>
						</div>
						<div>
							<p style="statistics_name">未完成24小时总量</p>
							<p class="statistics_number">{{stateList.dayTakeOrdersCount}}</p>
						</div>
						<div>
							<p style="statistics_name">超7天未完成总量</p>
							<p class="statistics_number">{{stateList.weekUncompleteCount}}</p>
						</div>
					</div>
					<Page ref="pageModel" :total="pageCount" :display="pageSize" :pagegroup="3" :currentspage="1"
						@parentMethod="search"></Page>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import "@/assets/css/common/list.css"
	import SearchList from "@/components/list/searchList";
	import BtnList from "@/components/list/btnList";
	import List from "@/components/list/list";
	import Page from "@/components/common/page";
	import CommonJs from "@/assets/js/common/common.js";
	import staListJs from "@/assets/js/sticList/stic.js";
	import Statistics from "@/assets/js/statistics/statistics.js"
	export default {
		name: 'list',
		components: {
			List,
			SearchList,
			BtnList,
			Page
		},
		data() {
			const $this = this;
			return {
				paddingTop: 0,
				value1: '',
				searchDate: '',
				options: [],
				workloadList: [],
				checkboxList: [],
				ExcelList: [],
				customerList: [],
				tableList: [{
					column: 'supperName',
					title: '人员名称',
					headerAlign: 'center',
					align: 'center',
					width: '20%'
				}, {
					column: 'completeCount',
					title: '完成工单数量',
					headerAlign: 'center',
					align: 'center',
					width: '20%'
				}, {
					column: 'unCompleteCount',
					title: '未完成工单数量',
					headerAlign: 'center',
					align: 'center',
					width: '20%'
				}, {
					column: 'dayTakeOrdersCount',
					title: '超过24小时接单数量',
					headerAlign: 'center',
					align: 'center',
					width: '20%',

				}, {
					column: 'weekUncompleteCount',
					title: '超过7天未完成订单数量',
					headerAlign: 'center',
					align: 'center',
					width: '20%',
				}],
				multipleSelection: [],
				tableData: [],
				menuList: [],
				tableInfo: {},
				stateList: {},
				checkBox: {
					type: Boolean,
					default: false
				},
				searchList: {
					user: '',
					userId: '',
					time1: '',
					time2: '',
					city: '',
					district: '',
				},
				pageCount: 0,
				pageSize: 0,
				pageNo: 1,
				sheet: [{
					title: "工作量统计表",
					tHeader: [
						"人员名称",
						"完成工单数量",
						"未完成工单数量",
						"超过24小时接单数量",
						"超过7天未完成订单数量",
					],
					keys: [
						"supperName",
						"completeCount",
						"unCompleteCount",
						"dayTakeOrdersCount",
						"weekUncompleteCount",
					],
					table: [],
					sheetName: "工作量统计",
					cellStyle: [{
						cell: "A1",
						font: {
							name: "黑体",
							sz: "18px",
						},
					}],
				}],
			}
		},
		methods: {
			test(item) {
				if (item.district != null) {
					this.searchList.district = item.district;
				} else if (item === 'all') {
					this.searchList.city = '';
				} else {
					this.searchList.city = item;
				}
				this.search({
					pageNo: 1,
					pageSize: this.pageSize
				});
			},
			search(param) {
				this.searchList.time1 = this.searchDate ? this.searchDate[0] || '' : '';
				this.searchList.time2 = this.searchDate ? this.searchDate[1] || '' : '';
				this.searchList.user = this.checkboxList.join();
				var newParam = Object.assign(param, this.searchList);
				this.getWordLoadList(newParam)
				this.getCountByStateTggregate(newParam);

				this.searchList.district = '';
			},
			getExcelList() { //导出
				// this.searchList.time1 = this.searchDate ? this.searchDate[0] || '' : '';
				// this.searchList.time2 = this.searchDate ? this.searchDate[1] || '' : '';
				// this.searchList.user = this.checkboxList.join();
				// var newParam = Object.assign(this.searchList);
				// staListJs.getWorkloadStatisticsList(newParam)
				// 	.then((response) => {
				// 		const data = response.data;
				var list = [];
				var $this = this;
				this.ExcelList.forEach(function(item, index) {
					var newItem = {};
					newItem.supperName = item.supperName == null ? " " : item.supperName;
					newItem.completeCount = item.completeCount == null ? " " : item.completeCount;
					newItem.unCompleteCount = item.unCompleteCount == null ? " " : item.unCompleteCount;
					newItem.dayTakeOrdersCount = item.dayTakeOrdersCount == null ? " " : item.dayTakeOrdersCount;
					newItem.weekUncompleteCount = item.weekUncompleteCount == null ? " " : item
						.weekUncompleteCount;
					list.push(newItem);
				});
				this.sheet[0].table = list;
				// })
				// .catch((response) => {});
			},
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},
			getInfo(info) {
				this.tableInfo = info;
			},
			// getCheckInfo(info) {
			// 	this.checkboxInfo = info;
			// 	this.checkboxList = [];
			// 	for (var i = 0; i < this.checkboxInfo.length; i++) {
			// 		this.checkboxList.push(this.checkboxInfo[i].supperID)
			// 	}
			// },
			change(val) {
				this.checkboxInfo = val;
				this.checkboxList = [];
				for (var i = 0; i < this.checkboxInfo.length; i++) {
					this.checkboxList.push(this.checkboxInfo[i].supperID)
				}
				this.searchList.time1 = this.searchDate ? this.searchDate[0] || '' : '';
				this.searchList.time2 = this.searchDate ? this.searchDate[1] || '' : '';
				this.searchList.user = this.checkboxList.join();
				var newParam = Object.assign(this.searchList);
				staListJs.getWorkloadStatisticsList(newParam)
					.then((response) => {
						const data = response.data;
						this.ExcelList = data.data
					})
					.catch((response) => {});
			},
			getUserBy() {
				CommonJs.getUserByName().then((response) => {
					const data = response.data;
					this.supportPersonList = data.data;
					let list = [];
					for (var i = 0; i < this.supportPersonList.length; i++) {
						if (this.supportPersonList[i].fullName != "" && this.supportPersonList[i].fullName !=
							null) {
							list.push({
								id: this.supportPersonList[i].userId.toString(),
								name: this.supportPersonList[i].fullName,
							});
						}
					}
					this.customerList = list;
				});
			},
			getWordLoadList(param) {
				staListJs.getWorkloadStatistics(param).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.tableData = data.data.records;
						this.pageCount = data.data.total;
						this.pageNo = data.data.current;
					}
				});
			},
			async getCountByStateTggregate(param) {
				await Statistics.getCountByStateTggregate(param)
					.then((response) => {
						const data = response.data;
						if (data.code == 1) {
							console.log("data:" + JSON.stringify(data));
							this.stateList = data.data;
						}
					})
					.catch((response) => {});
			},
			getWindowHeight() {
				let height = '';
				height = this.$refs.tableList.clientHeight - 220;
				this.height = height;
				if (height > 550) {
					let line = parseInt((height - 10) / 50);
					if (this.pageSize != line) {
						this.pageSize = line;
					}
				} else {
					if (this.pageSize != 10) {
						this.pageSize = 10;
					}
				}
				this.search({
					pageNo: 1,
					pageSize: this.pageSize
				});
			},
		},
		created() {
			this.getCountByStateTggregate();
			this.menuList = this.$store.getters.getMenuPermission;
			var a = [];
			a.push(new Date(Date.UTC(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() - 6))
				.toISOString().slice(
					0, 10));
			a.push(new Date(Date.UTC(new Date().getFullYear(), new Date().getMonth(), new Date().getDate())).toISOString()
				.slice(
					0, 10));
			this.searchDate = a;
		},
		mounted() {
			this.paddingTop = '140px';
			this.getWindowHeight();
			window.onresize = () => {
				// this.$refs.list.getHeight();
				this.getWindowHeight();
			}
			this.getUserBy();
			window.test = this.test;
		}
	}
</script>



// WEBPACK FOOTER //
// src/pages/statisticsList/workLoad.vue